//import Vue from 'vue'
import VueWechatTitle from 'vue-wechat-title'
import App from './App'
import router from './router'
import store from './store'
import MintUI from 'mint-ui'
import * as cookieUtil from '@/utils/cookieUtil'
import 'mint-ui/lib/style.css'
import {Button, Field, DatetimePicker} from 'mint-ui'
import commonUtil from "./utils/commonUtil";

Vue.use(MintUI);
Vue.use(VueRouter);
Vue.component(Button.name, Button);
Vue.component(Field.name, Field);
Vue.component(DatetimePicker.name, DatetimePicker);

Vue.config.productionTip = false;

cookieUtil.set('hospitalId', commonUtil.getHospitalId());
//cookieUtil.set('customerId', '180075');
//cookieUtil.set('token','eyJ0eXAiOiJKV1QiLCJjdHkiOiJKV1QiLCJ6aXAiOiJERUYiLCJhbGciOiJSUzUxMiJ9.eNqqVsrNT8rMSVWyUjI0NlbSUcpMUbIytDAwMDfVUSotTi3yS8wFST6bu-LZzMkvJncClaRWFADVmJpbmlpYmhiY1gIAAAD__w.djY0nvnt8Vu8FA51-Er7x8IdM42e8Z-BH9P_vy6wFBehE0yhubgEdGn_ymXzBVZSzQMe967id_VLs74rWNAuMkV1o_S5frgrdkyZolHoyP0IyvbhZHa4xhmUyjs3bmSvqzNHC2y4oY039-MOdzok0nJhZ0Jwx91dpgfqIfPg9ek');
router.beforeEach((to, from, next) => {
  // cookieUtil.set('token','eyJ0eXAiOiJKV1QiLCJjdHkiOiJKV1QiLCJ6aXAiOiJERUYiLCJhbGciOiJSUzUxMiJ9.eNqqVsrNT8rMSVWyUjI0tbQ0M7KwMDY0UdJRykxRsrIwBYoZ6SiVFqcW-SXmghQ9m9tnaGgIlE-tKFCyMjQ1Nbc0NzUwsawFAAAA__8.ei-5aN_a6y6G3eFma_nVGpk7g7VYykOJhlHOxlWuegjVHO0ryZ_UzpJw_QI6jKZdKxOKxgDbtiRO_N5zBp7NTqP4xDAbY4SD4q0Q-920UGrwQM2SlraN8oiM9VlWvE4ltrzW97Jzdvdm8YMiVPnoFxO3xsPDr0Um4FhKmkg5gvI')
  if (!cookieUtil.get('hospitalId')) {
      cookieUtil.set('hospitalId', commonUtil.getHospitalId())
  }
  console.log(to.path);
  if (to.path.indexOf('debug') > -1) {
    next();
  } else {
    const token = cookieUtil.get('token') || '';
    console.log(token);
    if (to.meta.title) {
      document.title = to.meta.title
    }
    if (token) {
      // 有token
      if (!store.getters.customerName) {
        store.dispatch('GetCustomerInfo').then((res) => {
          if (res.statusCode == 200) {
            next()
          }
        })
      } else {
        next()
      }
    } else {
      // 没有token
      if (to.path !== '/login' && to.path !== '/customer') {
        cookieUtil.set('redirectUrl', to.fullPath)
        next({
          path: '/login'
        })
      } else {
        next()
      }
    }
  }
})

Vue.use(VueWechatTitle);
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js